// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/slkscr.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/slkscrb.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/slkscre.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/slkscreb.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

body {
  background-color: #e9b2d0;
}

@font-face {
  font-family: 'SLKSCR';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
  font-family: 'SLKSCRBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
  font-family: 'SLKSCRE';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
  font-family: 'SLKSCREBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

::-webkit-scrollbar {
  width: 12px;
  background-color: #956a4f;
  border-radius: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: #463124;
  border-radius: 6px;
  border: 2px solid #956a4f;
  height: 10px;
}

::-webkit-scrollbar-corner {
  background-color: #956a4f;
  border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #5c2f1b;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+DAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,+DAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,+DAAkD;AACpD;;AAEA;EACE,0BAA0B;EAC1B,+DAAmD;AACrD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".App {\n  text-align: center;\n}\n\nbody {\n  background-color: #e9b2d0;\n}\n\n@font-face {\n  font-family: 'SLKSCR';\n  src: url('./fonts/slkscr.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'SLKSCRBold';\n  src: url('./fonts/slkscrb.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'SLKSCRE';\n  src: url('./fonts/slkscre.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'SLKSCREBold';\n  src: url('./fonts/slkscreb.ttf') format('truetype');\n}\n\n::-webkit-scrollbar {\n  width: 12px;\n  background-color: #956a4f;\n  border-radius: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #463124;\n  border-radius: 6px;\n  border: 2px solid #956a4f;\n  height: 10px;\n}\n\n::-webkit-scrollbar-corner {\n  background-color: #956a4f;\n  border-radius: 6px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #5c2f1b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
